import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  AdaptiveScanningResumeBody,
  ApplicationsContract,
} from '@terra/shared-contracts-applications';
import { applicationsClient } from '@terra/shared-rest-clients-applications';
import { terraApiWrapper } from '../../utils/terraApiWrapper';
import { ADAPTIVE_SCANNING_STATE_QUERY_KEY } from './useAdaptiveScanningState';

export const useResumeAdaptiveScanning = ({
  applicationId,
}: {
  applicationId: string;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: AdaptiveScanningResumeBody) =>
      terraApiWrapper<typeof ApplicationsContract.resumeAdaptiveScanning>({
        endpointFn: () =>
          applicationsClient.resumeAdaptiveScanning({
            params: { id: applicationId },
            body,
          }),
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [ADAPTIVE_SCANNING_STATE_QUERY_KEY, applicationId],
      });
    },
  });
};
